import React from "react";
import PathConstants from "./pathConstants";

// Report Appeal Result Flow
const ReportAppealResultPage = React.lazy(
  () => import("../pages/Product/ReportingFlow/ReportAppealResult"),
);
const AppealWonPage = React.lazy(
  () => import("../pages/Product/ReportingFlow/AppealWon"),
);
const ReviewAndSharePage = React.lazy(
  () => import("../pages/Product/ReportingFlow/ReviewAndShare"),
);
const DenialUpheldPage = React.lazy(
  () => import("../pages/Product/ReportingFlow/DenialUpheld"),
);
const DenialUpheldClaimFilePage = React.lazy(
  () => import("../pages/Product/ReportingFlow/DenialUpheldClaimFile"),
);
const AppealLostPage = React.lazy(
  () => import("../pages/Product/ReportingFlow/AppealLost"),
);

const routes = [
  {
    path: PathConstants.ReportAppealResult,
    element: <ReportAppealResultPage />,
  },
  {
    path: PathConstants.AppealWon,
    element: <AppealWonPage />,
  },
  {
    path: PathConstants.ReviewAndShare,
    element: <ReviewAndSharePage />,
  },
  {
    path: PathConstants.DenialUpheld,
    element: <DenialUpheldPage />,
  },
  {
    path: PathConstants.DenialUpheldClaimFile,
    element: <DenialUpheldClaimFilePage />,
  },
  {
    path: PathConstants.AppealLost,
    element: <AppealLostPage />,
  },
];

export default routes;
